
import VueI18n from 'vue-i18n'
import el from '@/locale/el.js'
import en from '@/locale/en.js'
import Vue from 'vue'
import store from '@/store'

const messages = { el, en }
Vue.use(VueI18n)

export default new VueI18n({
    locale: store.getters.getLanguage || 'el',
    messages
})
